/* eslint-disable no-param-reassign */
import api from '~/services';
import log from '~/helpers/log';

export default function useAccountChange() {
  async function setAccountChange(account) {
    try {
      await api.users.post.changeAccount(account);
    } catch (err) {
      log.error('Failed to change account.', err);
    }
  }

  return setAccountChange;
}
